/** Resolve fixture status into live | scheduled | finished. */

const LIVE = new Set(['1H', '2H', 'HT', 'ET', 'BT', 'P', 'LIVE', 'INT', 'INPLAY', 'BREAK']);
const FINISHED = new Set(['FT', 'AET', 'PEN', 'AWD', 'WO', 'ABD', 'CANC', 'PST', 'POSTP', 'SUSP']);
const SCHEDULED = new Set(['NS', 'TBD', 'TBA', 'SCHEDULED']);

const LIVE_WINDOW_MS = 3 * 60 * 60 * 1000;

export function rawStatusShort(matchOrStatus) {
  if (matchOrStatus == null) return '';
  if (typeof matchOrStatus === 'string' || typeof matchOrStatus === 'number') {
    return String(matchOrStatus);
  }
  const raw =
    matchOrStatus.status ??
    matchOrStatus.fixture?.status?.short ??
    matchOrStatus.fixture?.status;
  if (raw && typeof raw === 'object') return String(raw.short || '');
  return String(raw || '');
}

export function kickoffMs(match) {
  const t = new Date(match?.fixture?.date || match?.date || match?.time || 0).getTime();
  return Number.isNaN(t) ? 0 : t;
}

/**
 * Map API/catalog status → live | scheduled | finished.
 * Also corrects stale catalog labels using kickoff time:
 * - NS after kickoff+3h → finished
 * - NS after kickoff → live
 * - FT/LIVE before kickoff → scheduled (bad catalog data)
 */
export function resolveMatchBucket(match) {
  const short = rawStatusShort(match).toUpperCase().trim();
  const kickoff = kickoffMs(match);
  const now = Date.now();
  const hasKickoff = kickoff > 0;

  let bucket = 'scheduled';
  if (LIVE.has(short)) bucket = 'live';
  else if (FINISHED.has(short)) bucket = 'finished';
  else if (SCHEDULED.has(short) || !short) bucket = 'scheduled';
  else {
    const lower = short.toLowerCase();
    if (lower.includes('live') || lower.includes('progress')) bucket = 'live';
    else if (lower.includes('finish') || lower.includes('ended') || lower.includes('final')) {
      bucket = 'finished';
    }
  }

  if (!hasKickoff) return bucket;

  // Future kickoff cannot be live/finished yet (catalog often marks FT early)
  if (now < kickoff) return 'scheduled';

  // Stale NS / blank after kickoff
  if (bucket === 'scheduled') {
    if (now >= kickoff + LIVE_WINDOW_MS) return 'finished';
    return 'live';
  }

  // Live past the window → finished
  if (bucket === 'live' && now >= kickoff + LIVE_WINDOW_MS) return 'finished';

  return bucket;
}
